<template>
  <validation-observer ref="observer">
    <form @submit.prevent="submit" v-if="shaft" class="pt-2">
      <div class="d-flex flex-column align-center" style="position: relative">
        <div ref="swapImageContainer" />
        <ShaftImageBuildup
          :shaft="shaft"
          @addClick="onAddClicked"
          @editBuildupClick="onEditBuildupClicked"
          @editConeClick="onEditConeClicked"
          @svgLoaded="onSvgLoaded"
          :key="componentKey"
          :interactive="!shaft.ordered"
          :showLabels="true"
          style="position: absolute; background-color: white"
        />
      </div>
      <div class="my-4 pt-4 text-center">
        <v-btn
          color="primary"
          class="text-center"
          type="submit"
          :loading="isSubmitting"
          outlined
        >
          Speichern
        </v-btn>
      </div>
    </form>
    <v-dialog v-model="editDialogVisible" scrollable max-width="400px">
      <v-card>
        <v-card-title
          ><h5 class="text-uppercase">{{ editDialogTitle }}</h5></v-card-title
        >
        <v-card-text style="height: 300px">
          <v-radio-group v-model="editDialogChoice" column>
            <template v-for="item in editDialogChoices">
              <v-radio
                :key="item.id"
                :label="`${item.height} cm ${item.title}`"
                :value="item"
              ></v-radio>
              <v-divider :key="item.id + 'divider'" class="mb-2" />
            </template>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="onDeleteConfirmed">
            <v-icon class="mr-2">mdi-delete</v-icon>
            Löschen
          </v-btn>
          <v-btn color="primary" text @click="onEditConfirmed">
            Übernehmen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DialogConfirm
      ref="heightDialog"
      caption="Schachthöhe"
      :title="heightDialogTitle"
      :message="heightDialogMessage"
      ok="Speichern"
      cancel="Abbrechen"
    />
  </validation-observer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ShaftImageBuildup from '@/components/ShaftImageBuildup.vue';
import DialogConfirm from '@/components/DialogConfirm.vue';
import { calculateHeights } from '@/utils/utils';

export default {
  name: 'FormEditBuildup2',
  components: { ShaftImageBuildup, DialogConfirm },
  props: ['shaft', 'buildupChoices', 'coneChoices'],
  data: () => ({
    isSubmitting: false,
    componentKey: 0,
    editDialogVisible: false,
    editDialogTitle: '',
    editDialogBuildupItem: undefined,
    editDialogChoice: undefined,
    editDialogChoices: [],
    heightDialogTitle: undefined,
    heightDialogMessage: undefined,
  }),
  computed: {
    ...mapGetters([]),
  },
  methods: {
    ...mapActions(['updateCurrentShaft']),
    calculateHeights,
    async submit() {
      this.$refs.observer.validate().then(async success => {
        if (!success) {
          return;
        }

        if (!this.shaft.ordered) {
          var heights = calculateHeights(this.shaft);
          if (heights.diff !== 0) {
            if (heights.diff < 0) {
              this.heightDialogTitle = 'unter GOK';
              this.heightDialogMessage = `Ihre Schachtkonfiguration unterschreitet die GOK um ${-heights.diff} cm. Wollen Sie die Konfiguration speichern?`;
            } else if (heights.diff > 0) {
              this.heightDialogTitle = 'über GOK';
              this.heightDialogMessage = `Ihre Schachtkonfiguration überschreitet die GOK um ${heights.diff} cm. Wollen Sie die Konfiguration speichern?`;
            }
            var result = await this.$refs.heightDialog.show();
            if (!result) return;
          }

          this.isSubmitting = true;
          try {
            await this.updateCurrentShaft(this.shaft);
            this.$emit('submit');
          } catch {
            // ignored
          }
          this.isSubmitting = false;
        } else this.$emit('submit');
      });
    },
    clear() {
      this.$refs.observer.reset();
    },
    onAddClicked() {
      if (!this.shaft.buildups) {
        this.shaft.buildups = [];
      }

      const item =
        this.buildupChoices.length > 2
          ? this.buildupChoices[1]
          : this.buildupChoices[0];

      if (item) {
        this.shaft.buildups.push({ type: item });
        this.componentKey++; // force image to re-render
      }
    },
    onEditConeClicked() {
      this.editDialogTitle = 'Konus';
      this.editDialogBuildupItem = undefined;
      this.editDialogChoices = this.coneChoices.filter(
        choice =>
          choice.type !== 'Konus' ||
          choice.title.toLowerCase().indexOf(this.shaft.clamp.toLowerCase()) >=
            0,
      );
      if (this.shaft.cone) {
        this.editDialogChoice = this.editDialogChoices.find(
          choice => choice.id === this.shaft.cone.id,
        );
      } else this.editDialogChoice = undefined;
      this.editDialogVisible = true;
    },
    onEditBuildupClicked(item) {
      this.editDialogTitle = 'Schachtringhöhe';
      this.editDialogChoices = this.buildupChoices.filter(
        choice =>
          choice.title.toLowerCase().indexOf(this.shaft.clamp.toLowerCase()) >=
          0,
      );
      if (item.type) {
        this.editDialogChoice = this.editDialogChoices.find(
          choice => choice.id === item.type.id,
        );
      } else this.editDialogChoice = undefined;
      this.editDialogBuildupItem = item;
      this.editDialogVisible = true;
    },
    onEditConfirmed() {
      this.editDialogVisible = false;
      if (this.editDialogBuildupItem) {
        this.editDialogBuildupItem.type = this.editDialogChoice;
      } else {
        this.shaft.cone = this.editDialogChoice;
      }
      this.componentKey++;
    },
    onDeleteConfirmed() {
      this.editDialogVisible = false;
      var index = this.shaft.buildups.indexOf(this.editDialogBuildupItem);
      this.shaft.buildups.splice(index, 1);
      this.componentKey++;
    },
    onSvgLoaded(svg) {
      this.$refs.swapImageContainer.innerHTML = svg;
    },
  },
};
</script>

<style scoped>
.buildup-container {
  max-width: 400px;
}
</style>
